module.exports = __webpack_public_path__ + "bd.svg?b2af31760187b0f75eb6789dda71f62f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bd.svg
// module id = 992
// module chunks = 0